import { mergeStyles } from "@fluentui/merge-styles";

export const comparisonDetailStyle = mergeStyles({
  marginRight: 10,
});

export const cardClass = mergeStyles({
  border: '1px solid #edebe9',
  boxShadow: '0 1.6px 3.6px 0 rgba(0,0,0,0.132), 0 0.3px 0.9px 0 rgba(0,0,0,0.108)',
  cursor: 'pointer',
});